import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateTimePickerSchema = templateNamedWidgetSchema.extend({
  type: z.literal('timePicker'),
  value: z.string(),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  withSeconds: z.boolean(),
  defaultValueType: z.enum(['none', 'now', 'startOfDay']),
  parameter: templateParameterV1Schema.optional(),
  reference: templateReferenceV1Schema,
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
});

export type TemplateTimePickerV1 = z.infer<typeof templateTimePickerSchema>;
